<template>
  <div class="person-list-table">
    <el-dialog
      title="报名人员列表"
      :visible.sync="personDialogVisible"
      width="60%"
    >
      <!-- 导出按钮 -->
      <el-dropdown @command="getcommand">
        <el-button type="info" :style="{ 'margin-bottom': '10px' }">
          导出到文档<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="excel">Excel</el-dropdown-item>
          <el-dropdown-item command="pdf">PDF</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 批量删除按钮 -->
      <el-button
        type="info"
        :style="{ 'margin-bottom': '10px', float: 'right' }"
        @click="multipleDelete"
        :disabled="deleteIds.length < 1"
      >
        批量删除
      </el-button>
      <el-alert
        :title="activitiesName"
        type="info"
        :closable="false"
        effect="dark"
        show-icon
        center
      >
      </el-alert>

      <el-table
        :data="personList"
        height="400"
        border
        style="width: 100%"
        stripe
        @selection-change="selectPersons"
        id="tableform"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column type="expand">
          <template slot-scope="scope" v-if="scope.row.otherInfo">
            <!-- ortherInfo信息展示 -->
            <el-row :gutter="20">
              <el-col :span="8">主播介绍:</el-col>
              <el-col :span="16"
                ><span>{{ scope.row.ortherInfo.Liveintroduce }}</span></el-col
              >
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">直播账号:</el-col>
              <el-col :span="16"
                ><span>{{ scope.row.ortherInfo.Liveaccount }}</span></el-col
              >
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">参赛平台:</el-col>
              <el-col :span="16"
                ><span>{{ scope.row.ortherInfo.platform }}</span></el-col
              >
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">粉丝数量:</el-col>
              <el-col :span="16"
                ><span>{{ scope.row.ortherInfo.Livefans }}</span></el-col
              >
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">直播经验:</el-col>
              <el-col :span="16"
                ><span>{{ scope.row.ortherInfo.Liveexperience }}</span></el-col
              >
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">主播形象图片:</el-col>
              <el-col :span="16">
                <div class="img-content">
                  <el-image
                    style="width: 85%; height: 85%"
                    :src="scope.row.ortherInfo.LivePersonal"
                    :fit="cover"
                  ></el-image>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">直播后台图片:</el-col>
              <el-col :span="16">
                <div
                  class="img-content"
                  v-for="(url, index) in scope.row.ortherInfo.Livebackstage"
                  :key="index"
                >
                  <el-image
                    style="width: 85%; height: 85%"
                    :src="url"
                    :fit="cover"
                  ></el-image>
                </div>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column label="姓名" align="center" prop="userName">
        </el-table-column>
        <el-table-column
          prop="idCard"
          label="身份证号"
          align="center"
          width="100"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column label="身份证正面照片" align="center" width="120">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.idCardFront != null"
              width="75%"
              contain
              class="image-slot"
              :src="scope.row.idCardFront"
              :preview-src-list="[scope.row.idCardFront]"
              fit="contain"
            ></el-image>
            <div v-else slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="	身份证反面照片" align="center" width="120">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.idCardBack != null"
              width="75%"
              contain
              class="image-slot"
              :src="scope.row.idCardBack"
              :preview-src-list="[scope.row.idCardBack]"
              fit="contain"
            ></el-image>
            <div v-else slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="报名渠道" align="center">
          <template slot-scope="scope">
            <el-tag type="primary">
              {{ scope.row.type === "0" ? "公众号" : "公共服务平台" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="用户类别" align="center">
          <template slot-scope="scope">
            <el-tag type="primary">
              {{ scope.row.userType === "1" ? "企业" : "个人" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="报名时间"
          align="center"
          width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="verifyTime"
          label="审核时间"
          align="center"
          width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="审核状态" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.verifyStatus === '0'
                  ? 'warning'
                  : scope.row.verifyStatus === '1'
                  ? 'success'
                  : 'danger'
              "
            >
              {{
                scope.row.verifyStatus === "0"
                  ? "待审核"
                  : scope.row.verifyStatus === "1"
                  ? "审核完成"
                  : "审核失败"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.verifyStatus == 0" class="check-btns">
              <span @click="examineStatus(scope.row.id, '1')">通过</span>
              <span @click="examineStatus(scope.row.id, '2')">不通过</span>
            </div>
            <template slot-scope="scope" v-else>
              <div class="delete-btn">
                <i
                  class="el-icon-delete"
                  @click="deletePerson(scope.row.id)"
                ></i>
              </div>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <!-- 报名列表分页器 -->
      <el-pagination
        background
        layout="total,prev, pager, next"
        :total="personTotal"
        @current-change="pageChange"
        :page-size="personQuery.limit"
        :current-page="personQuery.page"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
// 引入导出函数
import {  getpdf } from "@/utils/method.js";
export default {
  data() {
    return {
      // 弹框的显示与隐藏
      personDialogVisible: false,
      // 获取报名信息列表参数
      personQuery: {
        limit: 8,
        page: 1,
        acid: null,
      },
      // 报名信息列表
      personList: [],
      // 报名总人数
      personTotal: 0,
      // 活动名称
      activitiesName: "",
      // 审核报名参数
      checkQuery: {
        id: null,
        verifyStatus: "",
      },
      //  要删除的数据数组
      deleteIds: [],
    };
  },
  methods: {
    init(obj) {
      this.personQuery.acid = obj.id;
      this.activitiesName = obj.name;
      this.getPersonList();
      this.personDialogVisible = true;
    },
    // 获取报名信息列表函数
    getPersonList() {
      this.$ajaxGet(
        "/sys/activitiesSignupData/list/open",
        this.personQuery
      ).then(({ data }) => {
        console.log(data);
        if (data.code === 0) {
          this.personList = data.data.list;
          this.personTotal = data.data.totalCount;
        }
      });
    },
    // 分页器页数改变时触发
    pageChange(val) {
      this.personQuery.page = val;
      this.getPersonList();
    },
    // 修改用户报名审核状态
    examineStatus(id, status) {
      this.checkQuery.id = id;
      this.checkQuery.verifyStatus = status;
      this.$ajaxPost(
        "/sys/activitiesSignupData/update/open",
        this.checkQuery
      ).then(({ data }) => {
        console.log(data);
        if (data.code === 0) {
          this.getPersonList();
          this.$message.success("审核成功");
        }
      });
    },
    // 删除个人报名信息
    deletePerson(id) {
      this.$confirm("此操作将永久删除该条目,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteIds.push(id);
          this.deleteInfo(this.deleteIds);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 批量删除报名信息列表
    multipleDelete() {
      this.$confirm("确定要批量删除用户报名数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = [];
          for (let i = 0; i < this.deleteIds.length; i++) {
            ids[i] = this.deleteIds[i].id;
          }
          console.log(ids);
          this.deleteIds(ids);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "删除失败，请联系管理员",
          });
        });
    },
    // 删除报名信息封装
    deleteInfo(ids) {
      this.$ajaxPost("/sys/activitiesSignupData/delete/open", ids)
        .then(({ data }) => {
          console.log(data);
          if (data.code === 0) {
            this.getPersonList();
            this.deleteIds = [];
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          } else {
            this.deleteIds = [];
            this.$message({
              type: "error",
              message: "删除失败!",
            });
          }
        })
        .catch(() => {
          this.deleteIds = [];
        });
    },
    // 将报名信息导出
    getcommand(val) {
      if (val === "excel") {
        getexcel(this.personList);
      } else {
        getpdf();
      }
    },
    // 实现报名信息多选
    selectPersons(val) {
      this.deleteIds = val;
    },
  },
};
</script>

<style lang="less" scoped>
@primaryColor: #409eff;
.check-btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    color: @primaryColor;
    font-size: 12px;
    cursor: pointer;
    &:first-child:hover {
      color: #67c23a;
    }
    &:last-child:hover {
      color: #f56c6c;
    }
  }
}
.delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 12px;
    color: @primaryColor;
    cursor: pointer;
  }
}
.img-content {
  width: 40px;
  height: 40px;
}
</style>